import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences($input: NotificationPreferencesUpdateInput!) {
    updateNotificationPreferences(input: $input) {
      success
    }
  }
`;

export default function useNotificationPreferencesUpdate(userUuid) {
  const [updateNotificationPreferences, { errors, loading }] = useMutation(
    UPDATE_NOTIFICATION_PREFERENCES,
    {
      noThrow: true
    }
  );

  const saveNotificationPreferences = useCallback(
    (smsPhoneNumber, smsOptIn) => {
      updateNotificationPreferences({
        variables: {
          input: {
            userUuid,
            smsPhoneNumber,
            smsOptIn
          }
        }
      });
    },
    [updateNotificationPreferences, userUuid]
  );

  useError(errors);

  return {
    hasError: !!errors?.[0],
    loading,
    saveNotificationPreferences
  };
}
